// extracted by mini-css-extract-plugin
export default {"wrapper":"tab-module--wrapper--01c5b","selected":"tab-module--selected--1948b"};